import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './navbar.css';
import {
  setAssignedRoutesArray,
  setEmailRedux,
  setLoginAgencyID,
  setPasswordRedux,
  setUserToken
} from '../../Redux/UserSlice';
import './additionalSideBar.css';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { RequestQuoteRounded } from '@mui/icons-material';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import TimelineIcon from '@mui/icons-material/Timeline';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom';

import SettingsIcon from '@mui/icons-material/Settings';

const SideBar = props => {
  const currentScreen = useLocation();

  const [userRolePermissionsArray, setUserRolePermissionsArray] =
    useState(null);
  const [routesArray, setRoutesArray] = useState(null);
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);
  const selectedModuleName = sessionStorage.getItem('selectedModulePersist');

  const [selectedModule, setSelectedModule] = useState(selectedModuleName);
  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );

  const [navigate, setNavigate] = useState('');
  // const selectedModulePersist = sessionStorage.setItem('selectedModulePersist',selectedModule)
  setTimeout(() => {
    const Home = localStorage.getItem('Home');
    setNavigate(Home);
  }, 3000);

  const handleSelectedModule = selectedModuleName => {
    sessionStorage.setItem('selectedModulePersist', selectedModuleName);
    setSelectedModule(selectedModuleName);
  };

  useEffect(() => {
    setSelectedModule(selectedModuleName);
  }, [selectedModuleName]);

  useEffect(() => {
    // if (
    //   currentScreen.pathname === '/bookshipment' &&
    //   selectedModule === '/quick-quote'
    // ) {
    //   setSelectedModule('/quick-quote');
    // } else if (
    //   currentScreen.pathname === '/bookshipment' &&
    //   selectedModule === '/manage-shipments'
    // ) {
    //   setSelectedModule('/manage-shipments');
    // } else if (
    //   currentScreen.pathname === '/bookshipmentTL' &&
    //   selectedModule === '/quick-quote'
    // ) {
    //   setSelectedModule('/quick-quote');
    // } else if (
    //   currentScreen.pathname === '/bookshipmentTL' &&
    //   selectedModule === '/manage-shipments'
    // ) {
    //   setSelectedModule('/manage-shipments');
    // } else {
    //   setSelectedModule(currentScreen.pathname);
    // }
    setSelectedModule(currentScreen.pathname);
  }, [currentScreen.pathname]);

  const dispatch = useDispatch();

  useEffect(() => {
    // Use a Set to ensure unique values in the array
    const updatedArray = new Set();
    const routesArray = new Set();
    // Iterate through userRolePermissions
    userRolePermissions?.forEach(permission => {
      const allLevelsTrue =
        !permission.level1 &&
        !permission.level2 &&
        !permission.level3 &&
        !permission.level4 &&
        !permission.level5;

      if (!allLevelsTrue) {
        // Add the permissionName to the Set
        updatedArray.add(permission.permissionName);
        if (permission.permissionName.includes('Carriers')) {
          routesArray.add('/carriers');
        }
        if (permission.permissionName.includes('Users')) {
          routesArray.add('/users');
        }
        if (permission.permissionName.includes('Roles')) {
          routesArray.add('/roles');
        }
        if (permission.permissionName.includes('Manage-Shipments')) {
          routesArray.add('/manage-shipments');
        }

        if (permission.permissionName.includes('Locations')) {
          routesArray.add('/view-locations');
        }
        if (permission.permissionName.includes('Settings')) {
          routesArray.add('/settings');
        }
        if (permission.permissionName.includes('Quick')) {
          routesArray.add('/quick-quote');
        }
        if (permission.permissionName.includes('App-Registration')) {
          routesArray.add('/app-registration');
        }
        if (permission.permissionName.includes('Invoice-Audit')) {
          routesArray.add('/invoice-audit');
        }
        if (permission.permissionName.includes('Track-Shipments')) {
          routesArray.add('/track-shipments');
        }
        if (permission.permissionName.includes('Logs')) {
          routesArray.add('/Logs');
        }
      }
    });

    // Convert the Set back to an array and update the state
    setUserRolePermissionsArray(Array.from(updatedArray));
    setRoutesArray(Array.from(routesArray));
  }, [userRolePermissions]);

  useEffect(() => {
    dispatch(setAssignedRoutesArray(routesArray));
  }, [routesArray]);

  console.log(routesArray, 'routesArray');
  const isMobile = useIsMobile();

  return (
    <React.Fragment>
      {isMobile ? null : (
        <div
          class='w-100'
          style={{
            width: '100%',
            height: '10%',
            background: '#FFF',
            maxHeight: '100vh'
          }}
        >
          <div class='side-nav-bar' style={{ position: '' }}>
            <a class='side-nav-logo'>
              <svg
                width='74'
                height='46'
                viewBox='0 0 262 137'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M114.787 1.52588e-05L108.423 6.36398L123.308 21.2488C127.603 25.5445 134.568 25.5445 138.864 21.2488L153.749 6.36398L147.385 1.94595e-05L132.5 14.8848C131.719 15.6658 130.453 15.6658 129.672 14.8848L114.787 1.52588e-05Z'
                  fill='#3361FF'
                />
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M167.172 19.7867L160.808 13.4227L145.923 28.3076C141.627 32.6033 141.627 39.5681 145.923 43.8639L160.808 58.7489L167.172 52.385L152.287 37.4999C151.506 36.7189 151.506 35.4526 152.287 34.6715L167.172 19.7867Z'
                  fill='#3361FF'
                />
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M114.787 72.1716L108.423 65.8077L123.308 50.9229C127.603 46.6271 134.568 46.6271 138.864 50.9229L153.749 65.8077L147.385 72.1716L132.5 57.2869C131.719 56.5058 130.453 56.5058 129.672 57.2869L114.787 72.1716Z'
                  fill='#3361FF'
                />
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M95.0002 19.7867L101.364 13.4227L116.249 28.3076C120.545 32.6033 120.545 39.5681 116.249 43.8639L101.364 58.749L95 52.385L109.885 37.4999C110.666 36.7189 110.666 35.4526 109.885 34.6715L95.0002 19.7867Z'
                  fill='#3361FF'
                />
                <path
                  d='M1.6245 116.821C2.70749 117.191 3.88894 117.486 5.16885 117.707C6.47337 117.904 7.76558 118.003 9.04549 118.003C10.793 118.003 12.0853 117.929 12.9221 117.781C13.7836 117.609 14.3497 117.351 14.6205 117.006C14.8912 116.661 15.0266 116.218 15.0266 115.677C15.0266 115.209 14.9281 114.84 14.7312 114.569C14.5343 114.298 14.1528 114.089 13.5867 113.942C13.0206 113.769 12.1837 113.634 11.0761 113.535L8.63936 113.314C6.81796 113.142 5.37806 112.76 4.31968 112.169C3.28591 111.579 2.5475 110.791 2.10446 109.806C1.68603 108.797 1.47681 107.591 1.47681 106.188C1.47681 104.515 1.8091 103.161 2.47366 102.127C3.16284 101.093 4.27045 100.343 5.7965 99.8749C7.32254 99.3826 9.35316 99.1365 11.8884 99.1365C15.1866 99.1365 17.9064 99.5672 20.0478 100.429L19.937 105.45L19.8262 105.598C17.3895 104.736 14.842 104.305 12.1837 104.305C10.9038 104.305 9.91927 104.379 9.23009 104.527C8.54091 104.65 8.06094 104.859 7.79019 105.154C7.51944 105.45 7.38407 105.868 7.38407 106.41C7.38407 106.951 7.47022 107.357 7.64251 107.628C7.83942 107.899 8.22093 108.108 8.78704 108.256C9.35316 108.379 10.1777 108.502 11.2607 108.625L13.5867 108.883C15.5558 109.105 17.0695 109.499 18.1279 110.065C19.1863 110.631 19.9124 111.394 20.3062 112.354C20.7246 113.289 20.9338 114.434 20.9338 115.788C20.9338 117.437 20.5769 118.815 19.8631 119.923C19.174 121.006 18.0417 121.818 16.4665 122.359C14.8912 122.901 12.7867 123.172 10.1531 123.172C8.43015 123.172 6.87949 123.085 5.50113 122.913C4.12277 122.716 2.78133 122.458 1.47681 122.138V116.932L1.6245 116.821ZM30.5487 122.839H24.6414V99.4688H30.5487V108.403H39.4096V99.4688H45.3168V122.839H39.4096V113.203H30.5487V122.839ZM55.643 122.839H49.7357V99.4688H55.643V122.839ZM65.9908 122.839H60.0835V99.4688H70.4951C72.8334 99.4688 74.704 99.7518 76.107 100.318C77.5099 100.884 78.5191 101.807 79.1344 103.087C79.7498 104.367 80.0575 106.102 80.0575 108.293C80.0575 110.36 79.7498 112.046 79.1344 113.351C78.5191 114.631 77.5099 115.578 76.107 116.194C74.704 116.809 72.8334 117.117 70.4951 117.117H65.9908V122.839ZM69.5352 104.305H65.9908V112.28H69.5352C71.2827 112.28 72.4519 111.985 73.0426 111.394C73.6333 110.803 73.9287 109.77 73.9287 108.293C73.9287 106.89 73.6333 105.881 73.0426 105.265C72.4519 104.625 71.2827 104.305 69.5352 104.305ZM99.0634 122.839V104.453H92.4177V99.4688H111.616V104.453H104.971V122.839H99.0634ZM114.202 122.839V99.4688H131.555V104.268H120.109V108.699H130.041V113.498H120.109V118.04H131.555V122.839H114.202ZM151.928 117.781V122.433C150.746 122.679 149.589 122.864 148.457 122.987C147.325 123.11 145.983 123.172 144.433 123.172C142.439 123.172 140.753 122.999 139.375 122.655C138.021 122.31 136.926 121.707 136.089 120.846C135.276 119.96 134.686 118.717 134.317 117.117C133.947 115.517 133.763 113.462 133.763 110.951C133.763 108.539 133.947 106.557 134.317 105.007C134.686 103.456 135.276 102.262 136.089 101.426C136.926 100.564 138.021 99.9733 139.375 99.6534C140.753 99.3088 142.439 99.1365 144.433 99.1365C145.983 99.1365 147.325 99.198 148.457 99.3211C149.589 99.4195 150.746 99.6041 151.928 99.8749V104.675L151.817 104.748C150.783 104.502 149.786 104.33 148.826 104.231C147.866 104.108 146.685 104.047 145.282 104.047C144.15 104.047 143.214 104.133 142.476 104.305C141.762 104.453 141.196 104.761 140.778 105.228C140.359 105.696 140.064 106.385 139.891 107.296C139.744 108.207 139.67 109.425 139.67 110.951C139.67 112.551 139.744 113.843 139.891 114.828C140.064 115.788 140.359 116.514 140.778 117.006C141.196 117.498 141.762 117.83 142.476 118.003C143.214 118.175 144.15 118.261 145.282 118.261C146.66 118.261 147.829 118.224 148.789 118.15C149.774 118.052 150.758 117.88 151.743 117.634L151.928 117.781ZM160.96 122.839H155.052V99.4688H160.96V108.403H169.821V99.4688H175.728V122.839H169.821V113.203H160.96V122.839ZM197.123 122.839H191.216V99.4688H201.627C203.966 99.4688 205.836 99.7518 207.239 100.318C208.642 100.884 209.651 101.807 210.267 103.087C210.882 104.367 211.19 106.102 211.19 108.293C211.19 110.36 210.882 112.046 210.267 113.351C209.651 114.631 208.642 115.578 207.239 116.194C205.836 116.809 203.966 117.117 201.627 117.117H197.123V122.839ZM200.667 104.305H197.123V112.28H200.667C202.415 112.28 203.584 111.985 204.175 111.394C204.765 110.803 205.061 109.77 205.061 108.293C205.061 106.89 204.765 105.881 204.175 105.265C203.584 104.625 202.415 104.305 200.667 104.305ZM220.234 122.839H214.327V99.4688H225.477C228.406 99.4688 230.535 100.133 231.864 101.462C233.218 102.767 233.895 104.699 233.895 107.259C233.895 109.179 233.415 110.828 232.455 112.206C231.495 113.56 230.227 114.409 228.652 114.754L228.615 114.865C229.23 115.258 229.907 115.911 230.646 116.821C231.384 117.732 232.11 118.729 232.824 119.812C233.562 120.87 234.215 121.867 234.781 122.802V122.839H227.914L223.926 116.932C223.582 116.415 223.299 116.046 223.077 115.824C222.88 115.603 222.634 115.468 222.339 115.418C222.068 115.369 221.625 115.345 221.01 115.345H220.234V122.839ZM224.517 104.268H220.234V110.545H224.517C225.748 110.545 226.597 110.299 227.064 109.806C227.557 109.314 227.803 108.514 227.803 107.407C227.803 106.299 227.557 105.499 227.064 105.007C226.597 104.515 225.748 104.268 224.517 104.268ZM237.385 111.136C237.385 108.157 237.717 105.794 238.382 104.047C239.071 102.299 240.24 101.044 241.889 100.281C243.563 99.518 245.889 99.1365 248.867 99.1365C251.107 99.1365 252.965 99.3457 254.442 99.7641C255.919 100.183 257.088 100.859 257.949 101.795C258.811 102.73 259.414 103.973 259.759 105.524C260.128 107.05 260.312 108.92 260.312 111.136C260.312 113.375 260.128 115.271 259.759 116.821C259.414 118.347 258.811 119.578 257.949 120.513C257.088 121.449 255.919 122.126 254.442 122.544C252.965 122.962 251.107 123.172 248.867 123.172C246.627 123.172 244.769 122.962 243.292 122.544C241.815 122.126 240.646 121.449 239.785 120.513C238.923 119.578 238.308 118.347 237.939 116.821C237.569 115.271 237.385 113.375 237.385 111.136ZM248.867 118.003C250.442 118.003 251.624 117.806 252.411 117.412C253.199 117.018 253.728 116.329 253.999 115.345C254.27 114.335 254.405 112.932 254.405 111.136C254.405 109.363 254.27 107.985 253.999 107.001C253.728 106.016 253.199 105.327 252.411 104.933C251.624 104.515 250.442 104.305 248.867 104.305C247.316 104.305 246.135 104.515 245.323 104.933C244.535 105.327 243.994 106.016 243.698 107.001C243.427 107.985 243.292 109.363 243.292 111.136C243.292 112.932 243.427 114.335 243.698 115.345C243.994 116.329 244.535 117.018 245.323 117.412C246.135 117.806 247.316 118.003 248.867 118.003Z'
                  fill='#354463'
                />
              </svg>
            </a>
            <hr />
            {UserIsAdmin ? (
              <>
                {/* <a className='side-nav-btn' href='/quick-quote' style={{backgroundColor: 'rgb(25, 118, 210)'}}>
                <RequestQuoteRounded style={{ color: 'white' }} />
                <span className='side-nav-btn-span text-white'>Quick Quote</span>
                </a> */}

                <Link
                  className={`side-nav-btn ${
                    selectedModule === '/quick-quote' ||
                    selectedModule === '/bookshipment' ||
                    selectedModule === '/bookshipmentTL'
                      ? 'highlighted'
                      : ''
                  }`}
                  to='/quick-quote'
                >
                  <RequestQuoteRounded />
                  <span className='side-nav-btn-span'>Quick Quote</span>
                </Link>

                <Link
                  className={`side-nav-btn ${
                    selectedModule === '/dashboard' ? 'highlighted' : ''
                  }`}
                  to='/dashboard'
                >
                  <DashboardOutlinedIcon />
                  <span className='side-nav-btn-span'>Dashboard</span>
                </Link>

                <Link
                  to='/carriers'
                  className={`side-nav-btn ${
                    selectedModule === '/carriers' ||
                    selectedModule === '/create-carrier'
                      ? 'highlighted'
                      : ''
                  }`}
                >
                  <LocalShippingOutlinedIcon />
                  <span className='side-nav-btn-span'>Carriers</span>
                </Link>

                <Link
                  to='/users'
                  className={`side-nav-btn ${
                    selectedModule === '/users' ? 'highlighted' : ''
                  }`}
                >
                  <GroupOutlinedIcon />
                  <span className='side-nav-btn-span'>Users</span>
                </Link>

                <Link
                  to='/roles'
                  className={`side-nav-btn ${
                    selectedModule === '/roles' ? 'highlighted' : ''
                  }`}
                >
                  <LockPersonIcon />
                  <span className='side-nav-btn-span'>Roles</span>
                </Link>

                <Link
                  to='/manage-shipments'
                  className={`side-nav-btn ${
                    selectedModule === '/' ||
                    selectedModule === '/manage-shipments' ||
                    selectedModule === '/dispatchshipmentTL' ||
                    selectedModule === '/dispatchshipmentParcel' ||
                    selectedModule === '/dispatchshipmentLTL'
                      ? 'highlighted'
                      : ''
                  }`}
                >
                  <svg
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                    style={{
                      fill:
                        selectedModule === '/' ||
                        selectedModule === '/manage-shipments' ||
                        selectedModule === '/dispatchshipmentTL' ||
                        selectedModule === '/dispatchshipmentParcel' ||
                        selectedModule === '/dispatchshipmentLTL'
                          ? '#f0f0f0'
                          : '#757575' // Change color on click
                    }}
                  >
                    <path d='M6.33333 6.0625L8 5.22917L9.66667 6.0625V2.10417H6.33333V6.0625ZM3.83333 12.1042V10.4375H8V12.1042H3.83333ZM2.16667 15.4375C1.70833 15.4375 1.31583 15.2744 0.989167 14.9483C0.663055 14.6217 0.5 14.2292 0.5 13.7708V2.10417C0.5 1.64583 0.663055 1.25333 0.989167 0.926667C1.31583 0.600555 1.70833 0.4375 2.16667 0.4375H13.8333C14.2917 0.4375 14.6842 0.600555 15.0108 0.926667C15.3369 1.25333 15.5 1.64583 15.5 2.10417V13.7708C15.5 14.2292 15.3369 14.6217 15.0108 14.9483C14.6842 15.2744 14.2917 15.4375 13.8333 15.4375H2.16667ZM2.16667 13.7708H13.8333V2.10417H11.3333V8.77083L8 7.10417L4.66667 8.77083V2.10417H2.16667V13.7708Z' />
                  </svg>
                  <span className='side-nav-btn-span'>Shipment</span>
                </Link>
                <Link
                  to='/view-locations'
                  className={`side-nav-btn ${
                    selectedModule === '/view-locations' ||
                    selectedModule === '/add-locations'
                      ? 'highlighted'
                      : ''
                  }`}
                >
                  <LocationOnOutlinedIcon />
                  <span className='side-nav-btn-span'>Locations</span>
                </Link>
                <Link
                  to='/app-registration'
                  className={`side-nav-btn ${
                    selectedModule === '/app-registration' ? 'highlighted' : ''
                  }`}
                >
                  <AccountTreeOutlinedIcon />
                  <span
                    style={{ textAlign: 'center' }}
                    className='side-nav-btn-span'
                  >
                    App Registration
                  </span>
                </Link>

                <Link
                  to='/track-shipment'
                  className={`side-nav-btn ${
                    selectedModule === '/track-shipment' ? 'highlighted' : ''
                  }`}
                >
                  <TimelineIcon />
                  <span
                    style={{ textAlign: 'center' }}
                    className='side-nav-btn-span'
                  >
                    Track Shipment
                  </span>
                </Link>
                <Link
                  onClick={() => handleSelectedModule('/Logs')}
                  to='/Logs'
                  className={`side-nav-btn ${
                    selectedModule === '/Logs' ? 'highlighted' : ''
                  }`}
                >
                  <WysiwygIcon />
                  <span
                    style={{ textAlign: 'center' }}
                    className='side-nav-btn-span'
                  >
                    Logs
                  </span>
                </Link>

                <Link
                  to='/settings'
                  className={`side-nav-btn ${
                    selectedModule?.toLowerCase() === '/settings'
                      ? 'highlighted'
                      : ''
                  }`}
                >
                  <SettingsIcon />
                  <span
                    style={{ textAlign: 'center' }}
                    className='side-nav-btn-span'
                  >
                    Settings
                  </span>
                </Link>
                <Link
                  to='/invoice-audit'
                  className={`side-nav-btn ${
                    selectedModule?.toLowerCase() === '/invoice-audit'
                      ? 'highlighted'
                      : ''
                  }`}
                >
                  <DescriptionOutlinedIcon />
                  <span
                    style={{ textAlign: 'center' }}
                    className='side-nav-btn-span'
                  >
                    Invoice-Audit
                  </span>
                </Link>
              </>
            ) : (
              userRolePermissionsArray && (
                <>
                  {userRolePermissionsArray.filter(items =>
                    items.includes('Quick')
                  ).length > 0 && (
                    <Link
                      className={`side-nav-btn ${
                        selectedModule === '/quick-quote' ||
                        selectedModule === '/bookshipment' ||
                        selectedModule === '/bookshipmentTL'
                          ? 'highlighted'
                          : ''
                      }`}
                      to='/quick-quote'
                    >
                      <RequestQuoteRounded />
                      <span className='side-nav-btn-span'>Quick Quote</span>
                    </Link>
                  )}
                  {userRolePermissionsArray.filter(items =>
                    items.includes('Dashboard')
                  ).length > 0 && (
                    <Link
                      className={`side-nav-btn ${
                        selectedModule === '/dashboard' ? 'highlighted' : ''
                      }`}
                      to='/dashboard'
                    >
                      <DashboardOutlinedIcon />
                      <span className='side-nav-btn-span'>Dashboard</span>
                    </Link>
                  )}

                  {userRolePermissionsArray.filter(items =>
                    items.includes('Carriers')
                  ).length > 0 && (
                    <Link
                      to='/carriers'
                      className={`side-nav-btn ${
                        selectedModule === '/carriers' ||
                        selectedModule === '/create-carrier'
                          ? 'highlighted'
                          : ''
                      }`}
                    >
                      <LocalShippingOutlinedIcon />
                      <span className='side-nav-btn-span'>Carriers</span>
                    </Link>
                  )}

                  {userRolePermissionsArray.filter(items =>
                    items.includes('Users')
                  ).length > 0 && (
                    <Link
                      to='/users'
                      className={`side-nav-btn ${
                        selectedModule === '/users' ? 'highlighted' : ''
                      }`}
                    >
                      <GroupOutlinedIcon />
                      <span className='side-nav-btn-span'>Users</span>
                    </Link>
                  )}

                  {userRolePermissionsArray.filter(items =>
                    items.includes('Roles')
                  ).length > 0 && (
                    <Link
                      to='/roles'
                      className={`side-nav-btn ${
                        selectedModule === '/roles' ? 'highlighted' : ''
                      }`}
                    >
                      <LockPersonIcon />
                      <span className='side-nav-btn-span'>Roles</span>
                    </Link>
                  )}

                  {userRolePermissionsArray.filter(items =>
                    items.includes('Manage-Shipments')
                  ).length > 0 && (
                    <Link
                      to='/manage-shipments'
                      className={`side-nav-btn ${
                        selectedModule === '/manage-shipments'
                          ? 'highlighted'
                          : ''
                      }`}
                    >
                      <svg
                        width='16'
                        height='16'
                        viewBox='0 0 16 16'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        style={{
                          fill:
                            selectedModule === '/manage-shipments'
                              ? '#f0f0f0'
                              : '#757575' // Change color on click
                        }}
                      >
                        <path d='M6.33333 6.0625L8 5.22917L9.66667 6.0625V2.10417H6.33333V6.0625ZM3.83333 12.1042V10.4375H8V12.1042H3.83333ZM2.16667 15.4375C1.70833 15.4375 1.31583 15.2744 0.989167 14.9483C0.663055 14.6217 0.5 14.2292 0.5 13.7708V2.10417C0.5 1.64583 0.663055 1.25333 0.989167 0.926667C1.31583 0.600555 1.70833 0.4375 2.16667 0.4375H13.8333C14.2917 0.4375 14.6842 0.600555 15.0108 0.926667C15.3369 1.25333 15.5 1.64583 15.5 2.10417V13.7708C15.5 14.2292 15.3369 14.6217 15.0108 14.9483C14.6842 15.2744 14.2917 15.4375 13.8333 15.4375H2.16667ZM2.16667 13.7708H13.8333V2.10417H11.3333V8.77083L8 7.10417L4.66667 8.77083V2.10417H2.16667V13.7708Z' />
                      </svg>
                      <span className='side-nav-btn-span'>Shipment</span>
                    </Link>
                  )}

                  {userRolePermissionsArray.filter(items =>
                    items.includes('Locations')
                  ).length > 0 && (
                    <Link
                      to='/view-locations'
                      className={`side-nav-btn ${
                        selectedModule === '/view-locations' ||
                        selectedModule === '/add-locations'
                          ? 'highlighted'
                          : ''
                      }`}
                    >
                      <LocationOnOutlinedIcon />
                      <span className='side-nav-btn-span'>Locations</span>
                    </Link>
                  )}

                  {userRolePermissionsArray.filter(items =>
                    items.includes('Reports')
                  ).length > 0 && (
                    <a className='side-nav-btn'>
                      <svg
                        width='14'
                        height='18'
                        viewBox='0 0 14 18'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M3.66927 8.9349V7.26823H10.3359V8.9349H3.66927ZM3.66927 5.60156V3.9349H10.3359V5.60156H3.66927ZM2.0026 10.6016H8.2526C8.65538 10.6016 9.03038 10.6884 9.3776 10.862C9.72483 11.0356 10.0165 11.2821 10.2526 11.6016L12.0026 13.8932V2.26823H2.0026V10.6016ZM2.0026 15.6016H11.2109L8.9401 12.6224C8.85677 12.5113 8.75608 12.4245 8.63802 12.362C8.51997 12.2995 8.39149 12.2682 8.2526 12.2682H2.0026V15.6016ZM12.0026 17.2682H2.0026C1.54427 17.2682 1.15191 17.105 0.825521 16.7786C0.499132 16.4523 0.335938 16.0599 0.335938 15.6016V2.26823C0.335938 1.8099 0.499132 1.41753 0.825521 1.09115C1.15191 0.764757 1.54427 0.601562 2.0026 0.601562H12.0026C12.4609 0.601562 12.8533 0.764757 13.1797 1.09115C13.5061 1.41753 13.6693 1.8099 13.6693 2.26823V15.6016C13.6693 16.0599 13.5061 16.4523 13.1797 16.7786C12.8533 17.105 12.4609 17.2682 12.0026 17.2682Z'
                          fill='#757575'
                        />
                      </svg>
                      <span className='side-nav-btn-span'>Reports</span>
                    </a>
                  )}

                  {userRolePermissionsArray.filter(items =>
                    items.includes('App-Registration')
                  ).length > 0 && (
                    <Link
                      to='/app-registration'
                      className={`side-nav-btn ${
                        selectedModule === '/app-registration'
                          ? 'highlighted'
                          : ''
                      }`}
                    >
                      <AccountTreeOutlinedIcon />
                      <span
                        style={{ textAlign: 'center' }}
                        className='side-nav-btn-span'
                      >
                        App Registration
                      </span>
                    </Link>
                  )}

                  {userRolePermissionsArray.filter(items =>
                    items.includes('Track-Shipments')
                  ).length > 0 && (
                    <Link
                      to='/track-shipment'
                      className={`side-nav-btn ${
                        selectedModule === '/track-shipment'
                          ? 'highlighted'
                          : ''
                      }`}
                    >
                      <TimelineIcon />
                      <span
                        style={{ textAlign: 'center' }}
                        className='side-nav-btn-span'
                      >
                        Track Shipment
                      </span>
                    </Link>
                  )}

                  {userRolePermissionsArray.filter(items =>
                    items.includes('Logs')
                  ).length > 0 && (
                    <Link
                      onClick={() => handleSelectedModule('/Logs')}
                      to='/Logs'
                      className={`side-nav-btn ${
                        selectedModule === '/Logs' ? 'highlighted' : ''
                      }`}
                    >
                      <WysiwygIcon />
                      <span
                        style={{ textAlign: 'center' }}
                        className='side-nav-btn-span'
                      >
                        Logs
                      </span>
                    </Link>
                  )}

                  {userRolePermissionsArray.filter(items =>
                    items.includes('Settings')
                  ).length > 0 && (
                    <Link
                      to='/settings'
                      className={`side-nav-btn ${
                        selectedModule?.toLowerCase() === '/settings'
                          ? 'highlighted'
                          : ''
                      }`}
                    >
                      <SettingsIcon />
                      <span
                        style={{ textAlign: 'center' }}
                        className='side-nav-btn-span'
                      >
                        Settings
                      </span>
                    </Link>
                  )}

                  {userRolePermissionsArray.filter(items =>
                    items.includes('Invoice-Audit')
                  ).length > 0 && (
                    <Link
                      to='/invoice-audit'
                      className={`side-nav-btn ${
                        selectedModule?.toLowerCase() === '/invoice-audit'
                          ? 'highlighted'
                          : ''
                      }`}
                    >
                      <DescriptionOutlinedIcon />
                      <span
                        style={{ textAlign: 'center' }}
                        className='side-nav-btn-span'
                      >
                        Invoice-Audit
                      </span>
                    </Link>
                  )}
                </>
              )
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default withRouter(SideBar);
